import { Box, useMediaQuery, useTheme } from "@mui/material"
import { Outlet } from "react-router-dom"
import SideBar from "../SideBar/SideBar";

const drawerWidth = 300;

const UserLayout = () => {

    
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
    return (
        <>
            <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
                <SideBar />
                <Box
                     component="main"
                     sx={{
                       flexGrow: 1,
                       p: isLgUp ? 5 : 1,
                       width: { sm: `calc(100% - ${drawerWidth}px)` },
                       marginTop: isLgUp ? "0px" : "80px",
                     }}
                >
                    <Outlet />
                </Box>
            </Box>
        </>
    )
}

export default UserLayout